import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Typography,
  IconButton,
  Collapse,
  useTheme,
} from "@mui/material";
import {
  Close,
  DesktopWindows,
} from "@mui/icons-material";
import withStyles from '@mui/styles/withStyles';

const styles = (theme) => ({
  banner: {
    position: 'sticky',
    top: 0,
    zIndex: 999,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
    transition: 'all 0.3s ease-in-out',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: 1200,
    margin: '0 auto',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
    },
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
    },
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: '6px',
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      width: 24,
      height: 24,
    },
  },
  desktopIcon: {
    fontSize: 16,
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.125),
  },
  mainText: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    lineHeight: 1.2,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },
  },
  subText: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    fontFamily: theme.typography.fontFamily,
    lineHeight: 1.1,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
    },
  },
  closeButton: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(0.5),
    width: 26,
    height: 26,
    minWidth: 26,
    transition: 'all 0.2s ease',
    [theme.breakpoints.down('sm')]: {
      width: 24,
      height: 24,
      minWidth: 24,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.primary.main,
    },
  },
});

function MobileNoticeBanner({ classes, deviceInfo }) {
  const [dismissed, setDismissed] = useState(() => {
    const dismissedValue = localStorage.getItem('mobileNoticeDismissed') === 'true';
    console.log('Banner dismissed state:', dismissedValue);
    return dismissedValue;
  });
  
  const theme = useTheme();
  
  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('mobileNoticeDismissed', 'true');
  };
  
  const getMessage = () => {
    if (deviceInfo?.deviceType === 'tablet') {
      return {
        main: "🎯 Better Experience Available",
        sub: "Auralyze works best on desktop with Chrome"
      };
    }
    return {
      main: "💻 Optimised for Desktop",
      sub: "Auralyze works best on desktop with Chrome"
    };
  };

  console.log('Banner render:', { dismissed, deviceInfo });
  const message = getMessage();

  return (
    <Collapse in={!dismissed}>
      <Box className={classes.banner}>
        <div className={classes.content}>
          <div className={classes.leftSection}>
            <div className={classes.iconContainer}>
              <DesktopWindows className={classes.desktopIcon} />
            </div>
            
            <div className={classes.textContainer}>
              <Typography className={classes.mainText}>
                {message.main}
              </Typography>
              <Typography className={classes.subText}>
                {message.sub}
              </Typography>
            </div>
          </div>
          
          <IconButton
            className={classes.closeButton}
            onClick={handleDismiss}
            size="small"
            aria-label="Dismiss notice"
          >
            <Close fontSize="small" />
          </IconButton>
        </div>
      </Box>
    </Collapse>
  );
}

MobileNoticeBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  deviceInfo: PropTypes.object,
};

export default withStyles(styles)(MobileNoticeBanner); 